<template>
  <span v-if="myself.lista !== null">
    <span
      id="printableList"
      :class="'wrapper-module-' + myself.lista.modulo.mod_tabela"
    >
      <component
        v-if="mycomponents['tpluser' + myself.module + '--pretop'] != null"
        v-bind:is="'tpluser' + myself.module + '--pretop'"
        :myself="myself"
      />

      <component
        v-if="
          mycomponents['tpluser' + myself.lista.modulo.tpl + '--pretop'] != null
        "
        v-bind:is="'tpluser' + myself.lista.modulo.tpl + '--pretop'"
        :myself="myself"
      />

      <component
        v-if="mycomponents['listagem-' + myself.module + '-pretop'] != null"
        v-bind:is="'listagem-' + myself.module + '-pretop'"
        :myself="myself"
      />

      <slot name="pretop" v-bind:myself="myself"></slot>

      <component
        v-if="
          myself.loading == false &&
            mycomponents['tpluser' + myself.module + '--top'] != null
        "
        v-bind:is="'tpluser' + myself.module + '--top'"
        :myself="myself"
      />

      <component
        v-else-if="
          myself.loading == false &&
            mycomponents['tpluser' + myself.lista.modulo.tpl + '--top'] != null
        "
        v-bind:is="'tpluser' + myself.lista.modulo.tpl + '--top'"
        :myself="myself"
      />

      <component
        v-else-if="
          myself.loading == false &&
            mycomponents['listagem-' + myself.module + '-top'] != null
        "
        v-bind:is="'listagem-' + myself.module + '-top'"
        :myself="myself"
      />

      <slot name="top" v-bind:myself="myself" v-else>
        <div class="breadcrumbs-default">
          <v-breadcrumbs
            class="breadcrumbs-default-list"
            dark
            v-if="myself.embed == null"
          >
            <v-breadcrumbs-item class="item-breadcrumbs-default-title">
              <h1
                v-if="myself.configprops.titulo"
                class="breadcrumbs-default-title"
              >
                {{ T(myself.lista.modulo.mod_titulo) }}
              </h1>
            </v-breadcrumbs-item>

            <v-breadcrumbs-item
              href="#/admin/page/cockpit"
              style="margin-left: 1rem !important"
            >
              <i class="v-icon mdi mdi-home-outline icon-breadcrumbs-home"></i>

              <div class="breadcrumbs-default-separator">
                <i
                  class="v-icon mdi mdi-chevron-double-right icon-breadcrumbs-separator"
                ></i>
              </div>
            </v-breadcrumbs-item>

            <v-breadcrumbs-item
              :href="`#/admin/app/${myself.module}/${myself.sid}/list`"
            >
              <p class="breadcrumbs-subtitle primary--text">
                {{ T(myself.lista.modulo.mod_titulo) }}
              </p>

              <div class="breadcrumbs-default-separator">
                <i
                  class="v-icon mdi mdi-chevron-double-right icon-breadcrumbs-separator"
                ></i>
              </div>
            </v-breadcrumbs-item>

            <v-breadcrumbs-item :disabled="true">
              {{
                (v => {
                  if (v == "new") return T("Inserir");
                  if (v == "edit") return T("Editar");
                  if (v == "flow") return T("Fluxo");
                  if (v == "list") return T("Listar");
                  if (v == "view") return T("Visualizar");
                })(myself.action)
              }}
            </v-breadcrumbs-item>
          </v-breadcrumbs>
        </div>

        <v-alert
          v-if="myself.errorMsg != null"
          :value="true"
          color="error"
          icon="warning"
          transition="scale-transition"
        >
          <span
            @dblclick="myself.showStack"
            v-if="myself.errorMsg == 'DENIED'"
            >{{ T("Permissão negada") }}</span
          >
          <span
            @dblclick="myself.showStack"
            v-else-if="myself.errorMsg == 'UNDEFINED'"
            >{{ T("Operação não permitida") }}</span
          >
          <span
            @dblclick="myself.showStack"
            v-else-if="
              myself.errorMsg.indexOf('Cannot delete or update a parent row') !=
                -1
            "
            >{{
              T(
                "Exclusão não permitida. Existem dependências que impedem a exclusão desse registro."
              )
            }}</span
          >
          <span
            v-else
            v-html="myself.errorMsg"
            @dblclick="myself.showStack"
          ></span>
        </v-alert>

        <v-dialog v-model="myself.errorBox.display" max-width="400">
          <v-alert
            :value="true"
            color="error"
            icon="warning"
            class="text-xs-left"
            v-html="myself.errorBox.text"
            transition="scale-transition"
          ></v-alert>

          <v-btn @click="myself.errorBox.display = false">{{
            T("Fechar")
          }}</v-btn>
        </v-dialog>

        <v-dialog v-model="myself.alertBox.display" max-width="400">
          <v-alert
            :value="true"
            color="success"
            icon="check_circle"
            class="text-xs-left"
            v-html="myself.alertBox.text"
            transition="scale-transition"
          ></v-alert>

          <v-btn @click="myself.alertBox.display = false">{{
            T("Fechar")
          }}</v-btn>
        </v-dialog>

        <v-progress-circular
          v-if="myself.loading == true"
          :size="70"
          :width="7"
          color="purple"
          indeterminate
        ></v-progress-circular>
      </slot>

      <component
        v-if="mycomponents['tpluser' + myself.module + '--postop'] != null"
        v-bind:is="'tpluser' + myself.module + '--postop'"
        :myself="myself"
      />

      <component
        v-if="
          mycomponents['tpluser' + myself.lista.modulo.tpl + '--postop'] != null
        "
        v-bind:is="'tpluser' + myself.lista.modulo.tpl + '--postop'"
        :myself="myself"
      />

      <component
        v-if="mycomponents['listagem-' + myself.module + '-postop'] != null"
        v-bind:is="'listagem-' + myself.module + '-postop'"
        :myself="myself"
      />

      <slot name="postop" v-bind:myself="myself"></slot>

      <template
        v-if="
          myself.action == 'list' &&
            myself.resultset !== null &&
            myself.errorMsg == null
        "
      >
        <template
          v-if="
            myself.lista.modulo.classe != null &&
              myself.lista.modulo.classe != ''
          "
        >
          <component
            v-bind:is="paginaMapeada"
            :forcepath="myself.lista.modulo.classe"
            :myself="myself"
          ></component>
        </template>

        <template v-else>
          <component
            v-if="
              myself.configprops.filtro &&
                myself.loading == false &&
                mycomponents['tpluser' + myself.module + '--filtros'] != null
            "
            v-bind:is="'tpluser' + myself.module + '--filtros'"
            :myself="myself"
          />

          <component
            v-else-if="
              myself.configprops.filtro &&
                myself.loading == false &&
                mycomponents[
                  'tpluser' + myself.lista.modulo.tpl + '--filtros'
                ] != null
            "
            v-bind:is="'tpluser' + myself.lista.modulo.tpl + '--filtros'"
            :myself="myself"
          />
          <component
            v-else-if="
              myself.configprops.filtro &&
                myself.loading == false &&
                mycomponents['listagem-' + myself.module + '-filtros'] != null
            "
            v-bind:is="'listagem-' + myself.module + '-filtros'"
            :myself="myself"
          />

          <!-- <div class="filter-default"> -->

          <slot
            name="filtros"
            v-bind:myself="myself"
            v-else-if="myself.configprops.filtro && myself.loading == false"
          >
            <v-card
              :class="
                'caixaDeFiltro pa-2 text-xs-left right mb-1 card-filter-default ' +
                  (myself.configprops.list === false
                    ? 'card-filter-default-only'
                    : '') +
                  ' ' +
                  (myself.embed ? 'card-filter-default-embed' : '')
              "
              :style="
                (myself.configprops.list === false
                  ? 'width:100%;'
                  : 'min-width:250px;') +
                  ' ' +
                  (filtrobox && myself.configprops.list !== false
                    ? 'z-index:101'
                    : '')
              "
            >
              <div class="filter-default-header">
                <h3 class="filter-default-title">
                  <span @click="filtrobox = !filtrobox">{{
                    T("Filtros")
                  }}</span>
                  <span
                    v-if="temAlgumFiltro"
                    class="ball-filter-arrow"
                    style="
                      background-color: #ccc;
                      display: inline;
                      margin-top: 2px;
                      font-size: 20px;
                    "
                    :title="T('Limpar todos os filtros')"
                  >
                    <v-icon
                      class="filter-default-header-icon"
                      style="cursor: pointer"
                      @click="limparTodoFiltro()"
                      >remove_circle_outline</v-icon
                    >
                  </span>
                </h3>

                <span
                  class="ball-filter-arrow"
                  :style="
                    temAlgumFiltro ? 'background-color:#ec4a2c!important;' : ''
                  "
                >
                  <v-icon
                    class="right filter-default-header-icon"
                    style="cursor: pointer"
                    @click="filtrobox = !filtrobox"
                    >{{
                      !filtrobox ? "keyboard_arrow_down" : "keyboard_arrow_up"
                    }}</v-icon
                  >
                </span>
              </div>

              <div class="filter-default-body" v-show="filtrobox">
                <article class="filter-default-table" border="1">
                  <section
                    class="section-filter-default"
                    v-for="(campo, index) in myself.configcruds[myself.module]
                      .filtrosShow"
                    :key="index"
                  >
                    <div class="filter-default-item">
                      <span class="label-filter-default" valign="top">{{
                        T(campo.cmp_titulo)
                      }}</span>

                      <crudcampo
                        modo="filtro"
                        :crud="myself"
                        v-model="
                          myself.localsession[myself.sid].filtro[
                            campo.cmp_coluna
                          ]
                        "
                        :campo="campo"
                        :row="myself.localsession[myself.sid].filtro"
                      ></crudcampo>
                    </div>

                    <div>
                      <span
                        class="ball-remove-filter"
                        @click="myself.hideFiltro(campo)"
                      >
                        <v-icon small>remove_circle</v-icon>
                      </span>
                    </div>
                  </section>

                  <section>
                    <div class="selecione-filter">
                      <v-select
                        class="left"
                        hide-details
                        :items="myself.configcruds[myself.module].filtrohide"
                        item-text="v"
                        item-value="k"
                        v-model="myself.configcruds[myself.module].filtrosel"
                        @change="myself.addFiltro()"
                        :placeholder="T('Incluir filtro')"
                      ></v-select>
                    </div>

                    <div class="text-xs-center">
                      <v-btn
                        id="botaoFiltarPadrao"
                        color="primary"
                        @click="
                          myself.filtrar();
                          filtrobox = false;
                        "
                      >
                        {{
                          myself.configprops.list === false
                            ? T("Pesquisar")
                            : T("Filtrar")
                        }}
                      </v-btn>
                    </div>
                  </section>
                </article>
              </div>
            </v-card>
          </slot>

          <!-- </div> -->

          <component
            v-if="
              myself.configprops.gc &&
                mycomponents['tpluser' + myself.module + '--gc'] != null
            "
            v-bind:is="'tpluser' + myself.module + '--gc'"
            :myself="myself"
          />

          <component
            v-else-if="
              myself.configprops.gc &&
                mycomponents['tpluser' + myself.lista.modulo.tpl + '--gc'] !=
                  null
            "
            v-bind:is="'tpluser' + myself.lista.modulo.tpl + '--gc'"
            :myself="myself"
          />

          <component
            v-else-if="
              myself.configprops.gc &&
                mycomponents['listagem-' + myself.module + '-gc'] != null
            "
            v-bind:is="'listagem-' + myself.module + '-gc'"
            :myself="myself"
          />

          <slot
            name="gc"
            v-bind:myself="myself"
            v-else-if="myself.configprops.gc"
          >
            <!-- dialog gerenciar campos -->

            <div class="dialog-default">
              <v-dialog
                v-if="myself.gerenciarDialog"
                width="500"
                hide-overlay
                transition="dialog-bottom-transition"
                v-model="myself.gerenciarDialog"
              >
                <v-card>
                  <div class="dialog-title-default">
                    <div class="btn-close-dialog">
                      <v-btn icon @click="myself.gerenciarCampos()">
                        <v-icon>close</v-icon>
                      </v-btn>
                    </div>

                    <p>{{ T("Colunas a serem exibidas") }}</p>

                    <h3>
                      {{
                        T(
                          "Selecione as colunas que devem ser exibidas na listagem"
                        )
                      }}
                    </h3>
                  </div>

                  <v-card-text>
                    <md-list>
                      <!--
                  <md-list
                    v-drag-and-drop:options="{dropzoneSelector: '.gercampos',draggableSelector: '.gerlinha',onDrop:myself.alterouOrdemCols}"
                  >
                      -->

                      <div class="gercampos mad-dialog-check">
                        <md-list-item
                          v-for="(co, index) in myself.lista.campos"
                          :trid="co.cmp_coluna"
                          class="gerlinha"
                          :key="index"
                          v-if="
                            co.cmp_lista == true &&
                              (myself.metadata._skip == null ||
                                myself.metadata._skip[co.cmp_coluna] !== true)
                          "
                        >
                          <md-checkbox
                            class="md-default"
                            v-model="
                              myself.configcruds[myself.module].displayCols[
                                co.cmp_coluna
                              ]
                            "
                            :value="1"
                            @change="myself._fillDataTable('colchanged')"
                          />
                          <span class="md-list-item-text">{{
                            T(co.cmp_titulo)
                          }}</span>
                        </md-list-item>
                      </div>
                    </md-list>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </div>
          </slot>

          <article
            class="content-tabelado"
            v-if="myself.configprops.list !== false"
          >
            <v-card class="card-full">
              <div class="header-tabelado">
                <component
                  v-if="
                    myself.configprops.acoes &&
                      myself.avaliaPermissao('add', null) &&
                      mycomponents['tpluser' + myself.module + '--addbtn'] !=
                        null
                  "
                  v-bind:is="'tpluser' + myself.module + '--addbtn'"
                  :myself="myself"
                />

                <component
                  v-else-if="
                    myself.configprops.acoes &&
                      myself.avaliaPermissao('add', null) &&
                      mycomponents[
                        'tpluser' + myself.lista.modulo.tpl + '--addbtn'
                      ] != null
                  "
                  v-bind:is="'tpluser' + myself.lista.modulo.tpl + '--addbtn'"
                  :myself="myself"
                />

                <component
                  v-else-if="
                    myself.configprops.acoes &&
                      myself.avaliaPermissao('add', null) &&
                      mycomponents['listagem-' + myself.module + '-addbtn'] !=
                        null
                  "
                  v-bind:is="'listagem-' + myself.module + '-addbtn'"
                  :myself="myself"
                />

                <slot
                  name="addbtn"
                  v-bind:myself="myself"
                  v-else-if="
                    myself.configprops.acoes &&
                      myself.avaliaPermissao('add', null)
                  "
                >
                  <v-btn
                    class="left addBotao"
                    color="success"
                    @click="myself.add()"
                    >{{ T(myself.lista.modulo.mod_acao_add) }}</v-btn
                  >
                </slot>

                <template
                  v-if="
                    myself.lista.campos.find(c => c.cmp_coluna == 'full_search')
                  "
                >
                  <component
                    v-if="
                      mycomponents[
                        'tpluser' + myself.module + '--full_search'
                      ] != null
                    "
                    v-bind:is="'tpluser' + myself.module + '--full_search'"
                    :myself="myself"
                  />
                  <component
                    v-else-if="
                      mycomponents[
                        'tpluser' + myself.lista.modulo.tpl + '--full_search'
                      ] != null
                    "
                    v-bind:is="
                      'tpluser' + myself.lista.modulo.tpl + '--full_search'
                    "
                    :myself="myself"
                  />

                  <component
                    v-else-if="
                      mycomponents[
                        'listagem-' + myself.module + '-full_search'
                      ] != null
                    "
                    v-bind:is="'listagem-' + myself.module + '-full_search'"
                    :myself="myself"
                  />
                  <slot name="full_search" v-bind:myself="myself" v-else>
                    <div
                      :style="
                        'width:' +
                          (myself.full_search_extract('width') || 300) +
                          'px;'
                      "
                      class="left full_search_bar"
                    >
                      <v-text-field
                        :label="
                          T(
                            myself.full_search_extract('placeholder') ||
                              'Busca rápida'
                          )
                        "
                        append-icon="search"
                        :loading="myself.full_search_loading"
                        v-model="myself.localsession[myself.sid].full_search"
                        @keyup="myself.full_search_press()"
                        @click:clear="
                          myself.localsession[myself.sid].full_search = '';
                          myself.full_search_press();
                        "
                        clearable
                      ></v-text-field>
                    </div>
                  </slot>
                </template>

                <div class="right-tabelado-header">
                  <component
                    v-if="
                      myself.configprops.exportscreen !== false &&
                        mycomponents[
                          'tpluser' + myself.module + '--exportscreen'
                        ] != null
                    "
                    v-bind:is="'tpluser' + myself.module + '--exportscreen'"
                    :myself="myself"
                  />
                  <component
                    v-else-if="
                      myself.configprops.exportscreen !== false &&
                        mycomponents[
                          'tpluser' + myself.lista.modulo.tpl + '--exportscreen'
                        ] != null
                    "
                    v-bind:is="
                      'tpluser' + myself.lista.modulo.tpl + '--exportscreen'
                    "
                    :myself="myself"
                  />

                  <component
                    v-else-if="
                      myself.configprops.exportscreen !== false &&
                        mycomponents[
                          'listagem-' + myself.module + '-exportscreen'
                        ] != null
                    "
                    v-bind:is="'listagem-' + myself.module + '-exportscreen'"
                    :myself="myself"
                  />
                  <slot
                    name="full_search"
                    v-bind:myself="myself"
                    v-else-if="myself.configprops.exportscreen !== false"
                  >
                    <v-speed-dial
                      class
                      v-model="myself.fab"
                      :open-on-hover="true"
                      direction="left"
                    >
                      <v-btn
                        slot="activator"
                        v-model="myself.fab"
                        color="primary"
                        fab
                        class="btn-speed-dial-tabelado"
                      >
                        <v-icon>share</v-icon>
                        <v-icon>close</v-icon>
                      </v-btn>

                      <v-btn
                        class="btn-speed-neb-tabelado oranger"
                        @click="myself.gerarExcel($refs)"
                        v-if="
                          myself.configprops.exportscreen.indexOf('e') !== -1
                        "
                        >XLS</v-btn
                      >
                      <v-btn
                        class="btn-speed-neb-tabelado reder"
                        @click="myself.gerarPDF($refs)"
                        v-if="
                          myself.configprops.exportscreen.indexOf('p') !== -1
                        "
                        >PDF</v-btn
                      >
                      <v-btn
                        class="btn-speed-neb-tabelado blacker"
                        @click="myself.gerarJSON($refs)"
                        v-if="
                          myself.configprops.exportscreen.indexOf('j') !== -1
                        "
                        >JSON</v-btn
                      >
                      <v-btn
                        class="btn-speed-neb-tabelado bluer"
                        @click="myself.gerarCSV($refs)"
                        v-if="
                          myself.configprops.exportscreen.indexOf('c') !== -1
                        "
                        >CSV</v-btn
                      >
                      <v-btn
                        class="btn-speed-neb-tabelado no-width-max printer"
                        @click="myself.gerarPrint()"
                        v-if="
                          myself.configprops.exportscreen.indexOf('i') !== -1
                        "
                      >
                        <v-icon>print</v-icon>
                      </v-btn>
                    </v-speed-dial>
                  </slot>

                  <div class v-if="myself.configprops.gc">
                    <component
                      v-if="
                        mycomponents['tpluser' + myself.module + '--gcbtn'] !=
                          null
                      "
                      v-bind:is="'tpluser' + myself.module + '--gcbtn'"
                      :myself="myself"
                    />

                    <component
                      v-else-if="
                        mycomponents[
                          'tpluser' + myself.lista.modulo.tpl + '--gcbtn'
                        ] != null
                      "
                      v-bind:is="
                        'tpluser' + myself.lista.modulo.tpl + '--gcbtn'
                      "
                      :myself="myself"
                    />

                    <component
                      v-else-if="
                        mycomponents['listagem-' + myself.module + '-gcbtn'] !=
                          null
                      "
                      v-bind:is="'listagem-' + myself.module + '-gcbtn'"
                      :myself="myself"
                    />
                    <slot name="gcbtn" v-bind:myself="myself" v-else>
                      <v-btn
                        color="primary gerenciarCampos"
                        @click="myself.gerenciarCampos()"
                        >{{ T("Gerenciar campos") }}</v-btn
                      >
                    </slot>
                  </div>
                </div>
              </div>

              <component
                v-if="
                  mycomponents['tpluser' + myself.module + '--predatatable'] !=
                    null
                "
                v-bind:is="'tpluser' + myself.module + '--predatatable'"
                :myself="myself"
              />

              <component
                v-if="
                  mycomponents[
                    'tpluser' + myself.lista.modulo.tpl + '--predatatable'
                  ] != null
                "
                v-bind:is="
                  'tpluser' + myself.lista.modulo.tpl + '--predatatable'
                "
                :myself="myself"
              />

              <component
                v-if="
                  mycomponents['listagem-' + myself.module + '-predatatable'] !=
                    null
                "
                v-bind:is="'listagem-' + myself.module + '-predatatable'"
                :myself="myself"
              />
              <slot name="predatatable" v-bind:myself="myself">
                <v-progress-linear
                  height="2"
                  style="position: fixed; bottom: 0px; left: 0px; width: 100%"
                  v-if="myself.loadingIntra"
                  :indeterminate="true"
                ></v-progress-linear>
              </slot>

              <component
                v-if="
                  myself.resultset !== null &&
                    mycomponents[
                      'listagem-' + myself.module + '-' + myself.action
                    ] != null
                "
                v-bind:is="'listagem-' + myself.module + '-' + myself.action"
                :myself="myself"
              />

              <template v-else v-for="n in [1, 2]">
                <component
                  v-if="
                    ((n == 1 && myself.optionsDrag == null) ||
                      (n == 2 && myself.optionsDrag != null)) &&
                      mycomponents['tpluser' + myself.module + '--datatable'] !=
                        null
                  "
                  :key="n"
                  v-bind:is="'tpluser' + myself.module + '--datatable'"
                  :myself="myself"
                  :n="n"
                />
                <component
                  v-else-if="
                    ((n == 1 && myself.optionsDrag == null) ||
                      (n == 2 && myself.optionsDrag != null)) &&
                      mycomponents[
                        'tpluser' + myself.lista.modulo.tpl + '--datatable'
                      ] != null
                  "
                  :key="n"
                  v-bind:is="
                    'tpluser' + myself.lista.modulo.tpl + '--datatable'
                  "
                  :myself="myself"
                  :n="n"
                />

                <component
                  v-else-if="
                    ((n == 1 && myself.optionsDrag == null) ||
                      (n == 2 && myself.optionsDrag != null)) &&
                      mycomponents[
                        'listagem-' + myself.module + '-datatable'
                      ] != null
                  "
                  :key="n"
                  v-bind:is="'listagem-' + myself.module + '-datatable'"
                  :myself="myself"
                  :n="n"
                />

                <slot
                  name="datatable"
                  v-bind:myself="myself"
                  v-bind:n="n"
                  v-else-if="
                    (n == 1 && myself.optionsDrag == null) ||
                      (n == 2 && myself.optionsDrag != null)
                  "
                >
                  <v-data-table
                    ref="datatableObj"
                    :key="n + '-' + datatable_resort"
                    v-drag-and-drop:options="
                      myself.optionsDrag != null
                        ? myself.optionsDrag
                        : {
                            dropzoneSelector: 'null',
                            draggableSelector: 'null'
                          }
                    "
                    :hide-actions="!myself.configprops.paginacao"
                    v-show="myself.loading == false"
                    v-model="myself.selected"
                    :headers="myself.headers"
                    :items="myself.resultset"
                    :pagination.sync="myself.paginationActive"
                    :total-items="myself.totalItems"
                    :rows-per-page-items="
                      n == 1
                        ? [
                            myself.lista.modulo.mod_paginacao
                              ? myself.lista.modulo.mod_paginacao * 1
                              : 20,
                            { text: T('Exibir todos'), value: -1 }
                          ]
                        : ['']
                    "
                    :rows-per-page-text="T('Registros por página')"
                    :loading="myself.loadingIntra"
                    item-key="id"
                    class="data-table-default"
                  >
                    <v-progress-linear
                      slot="progress"
                      color="blue"
                      indeterminate
                    ></v-progress-linear>
                    <template slot="headers" slot-scope="props">
                      <component
                        v-if="
                          mycomponents[
                            'tpluser' + myself.module + '--headers'
                          ] != null
                        "
                        v-bind:is="'tpluser' + myself.module + '--headers'"
                        :props="props"
                        :myself="myself"
                      />
                      <component
                        v-else-if="
                          mycomponents[
                            'tpluser' + myself.lista.modulo.tpl + '--headers'
                          ] != null
                        "
                        v-bind:is="
                          'tpluser' + myself.lista.modulo.tpl + '--headers'
                        "
                        :props="props"
                        :myself="myself"
                      />

                      <component
                        v-else-if="
                          mycomponents[
                            'listagem-' + myself.module + '-headers'
                          ] != null
                        "
                        v-bind:is="'listagem-' + myself.module + '-headers'"
                        :myself="myself"
                        :props="props"
                      />

                      <slot
                        name="headers"
                        v-bind:myself="myself"
                        v-else-if="
                          mycomponents[
                            'tpluser' + myself.module + '--headers'
                          ] == null &&
                            mycomponents[
                              'tpluser' + myself.lista.modulo.tpl + '--headers'
                            ] == null
                        "
                        v-bind:props="props"
                      >
                        <tr v-sortable="{ onEnd: updateHeaderOrder }">
                          <th
                            v-if="
                              myself.configprops.select &&
                                myself.lista.modulo.mod_numero
                            "
                          >
                            <v-checkbox
                              :input-value="props.all"
                              :indeterminate="props.indeterminate"
                              hide-details
                              @click.native="myself._toggleAll"
                            ></v-checkbox>
                          </th>

                          <th
                            class="text-xs-left"
                            v-for="header in myself.headers"
                            :key="header.text"
                            :keyname="header.value"
                            :class="[
                              'column',
                              header.sortable !== false ? 'sortable' : '',
                              myself.paginationActive.descending
                                ? 'desc'
                                : 'asc',
                              header.sortable ? ' boldlink' : '',
                              header.value === myself.paginationActive.sortBy
                                ? 'active'
                                : ''
                            ]"
                          >
                            <a
                              @click="myself.toggleGroup(header)"
                              v-if="header.campo.group === true"
                            >
                              <i
                                :style="
                                  'font-size:11px;' +
                                    (!myself.hasGroup(header)
                                      ? 'color:#ddd!important;'
                                      : '')
                                "
                                :title="T('Agrupar')"
                                class="material-icons theme--light"
                                >view_agenda</i
                              >
                            </a>

                            <span @click="myself._changeSort(header)">{{
                              T(header.text)
                            }}</span>
                            <v-icon small v-if="header.sortable !== false"
                              >arrow_upward</v-icon
                            >
                          </th>
                          <th v-if="myself.configprops.acoes">
                            <component
                              v-if="
                                mycomponents[
                                  'tpluser' + myself.module + '--loadmoretop'
                                ] != null
                              "
                              v-bind:is="
                                'tpluser' + myself.module + '--loadmoretop'
                              "
                              :myself="myself"
                            />

                            <component
                              v-if="
                                mycomponents[
                                  'tpluser' +
                                    myself.lista.modulo.tpl +
                                    '--loadmoretop'
                                ] != null
                              "
                              v-bind:is="
                                'tpluser' +
                                  myself.lista.modulo.tpl +
                                  '--loadmoretop'
                              "
                              :myself="myself"
                            />

                            <component
                              v-if="
                                mycomponents[
                                  'listagem-' + myself.module + '-loadmoretop'
                                ] != null
                              "
                              v-bind:is="
                                'listagem-' + myself.module + '-loadmoretop'
                              "
                              :myself="myself"
                            />
                            <slot name="loadmoretop" v-bind:myself="myself">
                              <span
                                class="text-xs-right"
                                v-if="
                                  myself.lista.modulo.mod_paginacao_infinita !=
                                    null
                                "
                                >{{ myself.totalItems }}
                                {{ T("registros") }}</span
                              >
                            </slot>
                          </th>
                        </tr>
                      </slot>
                    </template>
                    <template slot="items" slot-scope="props">
                      <component
                        v-if="
                          mycomponents['tpluser' + myself.module + '--items'] !=
                            null
                        "
                        v-bind:is="'tpluser' + myself.module + '--items'"
                        :props="props"
                        :myself="myself"
                      />
                      <component
                        v-else-if="
                          mycomponents[
                            'tpluser' + myself.lista.modulo.tpl + '--items'
                          ] != null
                        "
                        v-bind:is="
                          'tpluser' + myself.lista.modulo.tpl + '--items'
                        "
                        :props="props"
                        :myself="myself"
                      />

                      <component
                        v-else-if="
                          mycomponents[
                            'listagem-' + myself.module + '-items'
                          ] != null
                        "
                        v-bind:is="'listagem-' + myself.module + '-items'"
                        :myself="myself"
                        :props="props"
                      />

                      <slot
                        name="items"
                        v-bind:myself="myself"
                        v-else
                        v-bind:props="props"
                      >
                        <tr :active="props.selected" :trid="props.item['id']">
                          <td
                            class="noexport"
                            v-if="
                              myself.configprops.select &&
                                myself.lista.modulo.mod_numero
                            "
                            @click="props.selected = !props.selected"
                          >
                            <v-checkbox
                              :input-value="props.selected"
                              primary
                              hide-details
                            ></v-checkbox>
                          </td>

                          <td
                            v-for="coluna in myself.headers"
                            :key="coluna.text"
                            class="text-xs-left"
                          >
                            <crudcampo
                              :crud="myself"
                              v-model="props.item[coluna.value]"
                              :campo="coluna.campo"
                              :row="props.item"
                            ></crudcampo>
                          </td>
                          <td
                            class="text-xs-center center-content-flex"
                            v-if="myself.configprops.acoes"
                          >
                            <div class="data-table-list-icon noexportdata">
                              <template
                                v-if="
                                  myself.configcruds[myself.module].idiomas ==
                                    null
                                "
                              >
                                <v-icon
                                  :title="T('Editar')"
                                  v-if="
                                    myself.avaliaPermissao('edit', props.item)
                                  "
                                  class="data-table-icon-action"
                                  @click="myself.editItem(props.item)"
                                  >edit</v-icon
                                >
                              </template>

                              <template v-else>
                                <v-btn
                                  :title="T('Editar')"
                                  v-for="(z, index) of myself.configcruds[
                                    myself.module
                                  ].idiomas"
                                  :key="'edit_of_' + index"
                                  v-if="
                                    myself.avaliaPermissao('edit', props.item)
                                  "
                                  class="data-table-icon-action"
                                  @click="myself.editItem(props.item, z)"
                                  >{{ z }}</v-btn
                                >
                              </template>

                              <v-icon
                                v-if="
                                  myself.avaliaPermissao('add', props.item) &&
                                    myself.avaliaPermissao(
                                      'edit',
                                      props.item
                                    ) &&
                                    myself.configprops.clonar
                                "
                                class="data-table-icon-action"
                                @click="myself.cloneItem(props.item)"
                                >file_copy</v-icon
                              >

                              <v-icon
                                :title="T('Visualizar')"
                                v-if="
                                  myself.avaliaPermissao('view', props.item)
                                "
                                class="data-table-icon-action"
                                @click="myself.viewItem(props.item)"
                                >remove_red_eye</v-icon
                              >

                              <v-icon
                                :title="T('Excluir')"
                                v-if="myself.avaliaPermissao('del', props.item)"
                                class="data-table-icon-action"
                                @click="
                                  props.item.__deleting = true /*myself.deleteItem(props.item)*/
                                "
                                >delete</v-icon
                              >
                            </div>

                            <!-- <v-dialog v-model="props.item.__deleting" width="300">
                        <v-card>
                            <v-card-title class="title grey lighten-2" primary-title>Deseja realmente excluir o item selecionado?</v-card-title>
                            <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="grey" flat @click="props.item.__deleting = false;">Não</v-btn>
                            <v-btn color="primary" flat @click="props.item.__deleting = false; myself.deleteItem(props.item);">Sim</v-btn>
                            </v-card-actions>
                        </v-card>
                            </v-dialog>-->

                            <div class="dialog-default excluirItemTable">
                              <v-dialog
                                v-model="props.item.__deleting"
                                width="400"
                              >
                                <v-card>
                                  <div class="dialog-title-default">
                                    <p>{{ T("Excluir item") }}</p>

                                    <h3>
                                      {{
                                        T(
                                          "Deseja realmente excluir o item selecionado?"
                                        )
                                      }}
                                    </h3>
                                  </div>

                                  <div class="dialog-footer-default">
                                    <v-card-actions class="dialog-footer-btns">
                                      <v-btn
                                        color="grey"
                                        flat
                                        @click="props.item.__deleting = false"
                                        >{{ T("Não") }}</v-btn
                                      >

                                      <v-btn
                                        color="primary"
                                        @click="
                                          props.item.__deleting = false;
                                          myself.deleteItem(props.item);
                                        "
                                        >{{ T("Sim") }}</v-btn
                                      >
                                    </v-card-actions>
                                  </div>
                                </v-card>
                              </v-dialog>
                            </div>

                            <span
                              v-for="(custom, indc) in myself.lista.custom"
                              :key="'cs_' + indc"
                              @click="
                                myself
                                  .evaluatedCustom(
                                    custom,
                                    props.item.id,
                                    props.item
                                  )
                                  .action(props.item.id, props.item)
                              "
                            >
                              <template
                                v-if="
                                  custom.cus_massa == false &&
                                    myself.avaliaPermissao(
                                      'cs' + custom.cus_pk,
                                      props.item
                                    )
                                "
                              >
                                <span
                                  v-if="
                                    myself.evaluatedCustom(
                                      custom,
                                      props.item.id,
                                      props.item
                                    ).html
                                  "
                                  v-html="
                                    myself.evaluatedCustom(
                                      custom,
                                      props.item.id,
                                      props.item
                                    ).html
                                  "
                                ></span>
                                <v-btn
                                  small
                                  v-else-if="
                                    myself.evaluatedCustom(
                                      custom,
                                      props.item.id,
                                      props.item
                                    ).name
                                  "
                                >
                                  {{
                                    myself.evaluatedCustom(
                                      custom,
                                      props.item.id,
                                      props.item
                                    ).name
                                  }}
                                </v-btn>
                              </template>
                            </span>

                            <span
                              v-if="props.item._flow"
                              v-for="(status, indc) in props.item._flow"
                              :key="'flow_' + indc"
                            >
                              <template
                                v-if="
                                  myself.avaliaPermissao('flow_' + status.act)
                                "
                              >
                                <v-btn
                                  dark
                                  @click="myself.flowItem(props.item)"
                                  color="orange"
                                  small
                                  >{{ T(status.name) }}</v-btn
                                >
                              </template>
                            </span>

                            <span
                              v-if="props.item._flowaction"
                              v-for="(action, indc) in props.item._flowaction"
                              :key="'flowaction_' + indc"
                            >
                              <template
                                v-if="
                                  myself.avaliaPermissao(
                                    'flowact_' + action.act
                                  )
                                "
                              >
                                <v-btn
                                  dark
                                  color="green"
                                  @click="
                                    myself.callFlowAction(
                                      action.act,
                                      props.item.id
                                    )
                                  "
                                  small
                                  >{{ T(action.name) }}</v-btn
                                >
                              </template>
                            </span>
                            &nbsp;&nbsp;&nbsp;
                            <v-icon
                              v-if="myself.optionsDrag"
                              class="ml-2"
                              style="position: absolute; right: 20px"
                              >unfold_more</v-icon
                            >
                          </td>
                        </tr>
                      </slot>
                    </template>
                    <template slot="pageText" slot-scope="props">
                      <slot
                        name="pageText"
                        v-bind:myself="myself"
                        v-bind:props="props"
                        >{{
                          T("Exibindo %0 até %1 de %2", [
                            props.pageStart,
                            props.pageStop,
                            props.itemsLength
                          ])
                        }}</slot
                      >
                    </template>
                    <template slot="footer">
                      <component
                        v-if="
                          myself.configprops.rodape &&
                            mycomponents[
                              'tpluser' + myself.module + '--footer'
                            ] != null
                        "
                        v-bind:is="'tpluser' + myself.module + '--footer'"
                        :myself="myself"
                      />
                      <component
                        v-else-if="
                          myself.configprops.rodape &&
                            mycomponents[
                              'tpluser' + myself.lista.modulo.tpl + '--footer'
                            ] != null
                        "
                        v-bind:is="
                          'tpluser' + myself.lista.modulo.tpl + '--footer'
                        "
                        :myself="myself"
                      />

                      <component
                        v-else-if="
                          mycomponents[
                            'listagem-' + myself.module + '-footer'
                          ] != null
                        "
                        v-bind:is="'listagem-' + myself.module + '-footer'"
                        :myself="myself"
                      />

                      <slot
                        name="footer"
                        v-else-if="myself.configprops.rodape"
                        v-bind:myself="myself"
                      >
                        <td colspan="100%" class="text-xs-left">
                          <span
                            v-for="(custom, indc) in myself.lista.custom"
                            :key="indc"
                            @click="
                              myself
                                .evaluatedCustom(custom, myself.selected, null)
                                .action(myself.selected, null)
                            "
                          >
                            <template
                              v-if="
                                custom.cus_massa == true &&
                                  myself.avaliaPermissao(
                                    'cs' + custom.cus_pk,
                                    null
                                  )
                              "
                            >
                              <span
                                v-if="
                                  myself.evaluatedCustom(
                                    custom,
                                    myself.selected,
                                    null
                                  ).html
                                "
                                v-html="
                                  myself.evaluatedCustom(
                                    custom,
                                    myself.selected,
                                    null
                                  ).html
                                "
                              ></span>
                              <v-btn small v-else>
                                {{
                                  myself.evaluatedCustom(
                                    custom,
                                    myself.selected,
                                    null
                                  ).name
                                }}
                              </v-btn>
                            </template>
                          </span>

                          <div v-if="myself.metadata.rodape">
                            <v-layout row>
                              <v-flex
                                xs4
                                v-for="(roda, rk) in myself.lista.modulo.rodape"
                                :key="rk"
                              >
                                <strong>{{ T(roda.nome) }}:</strong>

                                <crudcampo
                                  :crud="myself"
                                  v-model="
                                    myself.metadata.rodape['rodape_col_' + rk]
                                  "
                                  modo="view"
                                  :campo="{
                                    cmp_coluna: 'rodape_col_' + rk,

                                    cmp_tipo:
                                      roda.componente || '' != ''
                                        ? roda.componente
                                        : 'text',
                                    componente: roda.componente,
                                    param: roda.componente_param,
                                    cmp_conta: roda.conta,
                                    cmp_titulo: T(roda.nome),
                                    cmp_view: true
                                  }"
                                  :row="myself.metadata.rodape"
                                ></crudcampo>
                              </v-flex>
                            </v-layout>
                          </div>
                        </td>
                      </slot>
                    </template>
                    <template slot="no-data">
                      <component
                        v-if="
                          mycomponents['tpluser' + myself.module + '--empty'] !=
                            null
                        "
                        v-bind:is="'tpluser' + myself.module + '--empty'"
                        :myself="myself"
                      />
                      <component
                        v-else-if="
                          mycomponents[
                            'tpluser' + myself.lista.modulo.tpl + '--empty'
                          ] != null
                        "
                        v-bind:is="
                          'tpluser' + myself.lista.modulo.tpl + '--empty'
                        "
                        :myself="myself"
                      />

                      <component
                        v-else-if="
                          mycomponents[
                            'listagem-' + myself.module + '-empty'
                          ] != null
                        "
                        v-bind:is="'listagem-' + myself.module + '-empty'"
                        :myself="myself"
                      />

                      <slot name="empty" v-bind:myself="myself" v-else>
                        <v-alert
                          :value="true"
                          color="white black--text"
                          icon="warning"
                          v-if="myself.loading == false"
                          transition="scale-transition"
                          >{{ T("Nenhum registro encontrado.") }}</v-alert
                        >
                        <div v-if="myself.loading == true">&nbsp;</div>
                      </slot>
                    </template>
                  </v-data-table>
                </slot>
              </template>

              <slot name="returnbtn" v-bind:myself="myself">
                <v-btn
                  v-if="
                    myself.localsession[myself.sid] &&
                      myself.localsession[myself.sid].joinedfrom != null
                  "
                  class="left"
                  @click="
                    myself.returnFromJoin(myself.localsession[myself.sid])
                  "
                  >{{ T("Retornar") }}</v-btn
                >
              </slot>

              <component
                v-if="
                  mycomponents['tpluser' + myself.module + '--loadmore'] != null
                "
                v-bind:is="'tpluser' + myself.module + '--loadmore'"
                :myself="myself"
              />

              <component
                v-if="
                  mycomponents[
                    'tpluser' + myself.lista.modulo.tpl + '--loadmore'
                  ] != null
                "
                v-bind:is="'tpluser' + myself.lista.modulo.tpl + '--loadmore'"
                :myself="myself"
              />

              <component
                v-if="
                  mycomponents['listagem-' + myself.module + '-loadmore'] !=
                    null
                "
                v-bind:is="'listagem-' + myself.module + '-loadmore'"
                :myself="myself"
              />
              <slot name="loadmore" v-bind:myself="myself">
                <div v-if="myself.lista.modulo.mod_paginacao_infinita != null">
                  <v-btn
                    @click="myself.loadNextPack()"
                    v-if="
                      myself.totalItems > myself.resultset.length &&
                        myself.lista.modulo.mod_paginacao_infinita == 'manual'
                    "
                    >{{ T("Carregar mais dados") }}</v-btn
                  >
                  <infinite-loading
                    v-if="
                      !myself.loadingIntra &&
                        myself.totalItems > myself.resultset.length &&
                        myself.lista.modulo.mod_paginacao_infinita == 'auto'
                    "
                    @infinite="myself.loadNextPack"
                    :distance="400"
                  ></infinite-loading>
                </div>
              </slot>

              <component
                v-if="
                  mycomponents['tpluser' + myself.module + '--posdatatable'] !=
                    null
                "
                v-bind:is="'tpluser' + myself.module + '--posdatatable'"
                :myself="myself"
              />

              <component
                v-if="
                  mycomponents[
                    'tpluser' + myself.lista.modulo.tpl + '--posdatatable'
                  ] != null
                "
                v-bind:is="
                  'tpluser' + myself.lista.modulo.tpl + '--posdatatable'
                "
                :myself="myself"
              />

              <component
                v-if="
                  mycomponents['listagem-' + myself.module + '-posdatatable'] !=
                    null
                "
                v-bind:is="'listagem-' + myself.module + '-posdatatable'"
                :myself="myself"
              />
              <slot name="posdatatable" v-bind:myself="myself"></slot>

              <component
                v-if="
                  myself.configprops.exportserver !== false &&
                    mycomponents[
                      'tpluser' + myself.module + '--exportserver'
                    ] != null
                "
                v-bind:is="'tpluser' + myself.module + '--exportserver'"
                :myself="myself"
              />
              <component
                v-else-if="
                  myself.configprops.exportserver !== false &&
                    mycomponents[
                      'tpluser' + myself.lista.modulo.tpl + '--exportserver'
                    ] != null
                "
                v-bind:is="
                  'tpluser' + myself.lista.modulo.tpl + '--exportserver'
                "
                :myself="myself"
              />

              <component
                v-else-if="
                  myself.configprops.exportserver !== false &&
                    mycomponents[
                      'listagem-' + myself.module + '-exportserver'
                    ] != null
                "
                v-bind:is="'listagem-' + myself.module + '-exportserver'"
                :myself="myself"
              />

              <slot
                name="exportserver"
                v-bind:myself="myself"
                v-else-if="myself.configprops.exportserver !== false"
              >
                <v-speed-dial
                  class="right"
                  v-model="myself.fab2"
                  :open-on-hover="true"
                  direction="left"
                  style="display: !important"
                >
                  <v-btn
                    slot="activator"
                    v-model="myself.fab2"
                    color="blue darken-2"
                    dark
                    fab
                    small
                    style="zoom: 75%; '-moz-transform': 'scale(75%)'"
                  >
                    <v-icon>share</v-icon>
                    <v-icon>close</v-icon>
                  </v-btn>

                  <v-btn
                    fab
                    dark
                    color="green"
                    small
                    @click="myself.gerarExcel($refs, 1)"
                    v-if="myself.configprops.exportserver.indexOf('e') !== -1"
                    >XLS</v-btn
                  >
                  <v-btn
                    fab
                    dark
                    color="indigo"
                    small
                    @click="myself.gerarPDF($refs, 1)"
                    v-if="myself.configprops.exportserver.indexOf('p') !== -1"
                    >PDF</v-btn
                  >
                  <v-btn
                    fab
                    dark
                    small
                    color="red"
                    @click="myself.gerarJSON($refs, 1)"
                    v-if="myself.configprops.exportserver.indexOf('j') !== -1"
                    >JSON</v-btn
                  >
                  <v-btn
                    fab
                    dark
                    small
                    @click="myself.gerarCSV($refs, 1)"
                    color="orange"
                    v-if="myself.configprops.exportserver.indexOf('c') !== -1"
                    >CSV</v-btn
                  >
                </v-speed-dial>
              </slot>
            </v-card>
          </article>
        </template>
      </template>

      <!-- -DIVISAO LIST FORM -->

      <template
        v-if="
          (myself.action == 'new' ||
            myself.action == 'edit' ||
            myself.action == 'flow' ||
            myself.action == 'view') &&
            myself.abas != null
        "
      >
        <article class="content-tabelado">
          <v-card
            :style="myself.lista.modulo.mod_cssstyle"
            :class="
              'card-full' +
                ' class_card_principal ' +
                (myself.lista.modulo.mod_cssclass || '')
            "
          >
            <component
              v-if="
                myself.form !== null &&
                  mycomponents['tpluser' + myself.module + '--form'] != null
              "
              v-bind:is="'tpluser' + myself.module + '--form'"
              :myself="myself"
            />
            <component
              v-else-if="
                myself.form !== null &&
                  mycomponents[
                    'tpluser' + myself.lista.modulo.tpl + '--form'
                  ] != null
              "
              v-bind:is="'tpluser' + myself.lista.modulo.tpl + '--form'"
              :myself="myself"
            />
            <component
              v-else-if="
                myself.form !== null &&
                  mycomponents['listagem-' + myself.module + '-form'] != null
              "
              v-bind:is="'listagem-' + myself.module + '-form'"
              :myself="myself"
            />

            <component
              v-else-if="
                myself.form !== null &&
                  mycomponents[
                    'listagem-' + myself.module + '-' + myself.action
                  ] != null
              "
              v-bind:is="'listagem-' + myself.module + '-' + myself.action"
              :myself="myself"
            />

            <slot
              name="form"
              v-bind:myself="myself"
              v-else-if="myself.form !== null"
            >
              <v-form
                ref="form"
                :class="'form_tabelado_' + myself.action"
                v-model="myself.valid"
                lazy-validation
              >
                <component
                  v-if="
                    myself.form !== null &&
                      absolutetpl &&
                      mycomponents['tpluser' + '--absoluteform'] != null
                  "
                  v-bind:is="'tpluser' + '--absoluteform'"
                  :myself="myself"
                  :absolutetplprop="absolutetpl"
                  @closeProp="absolutetpl = false"
                />
                <template v-else>
                  <div
                    v-for="(aba, index) in myself.abas"
                    :key="index"
                    v-if="aba.nome == null"
                  >
                    <slot
                      name="secao"
                      v-bind:myself="myself"
                      v-bind:aba="aba"
                      v-bind:index="index"
                      v-bind:secao="secao"
                      v-bind:indexsec="indexsec"
                      v-for="(secao, indexsec) in aba.secoes"
                      v-if="secao.campos.length > 0"
                    >
                      <v-card
                        class="'pa-2 elevation-0 class_secao'"
                        :key="indexsec"
                      >
                        <v-toolbar v-if="secao.nome != null">
                          <v-toolbar-title>{{ T(secao.nome) }}</v-toolbar-title>
                        </v-toolbar>
                        <v-layout row wrap style="position: relative">
                          <template v-for="(campo, index) in secao.campos">
                            <template
                              v-if="
                                campo.m == null &&
                                  (myself.metadata._skip == null ||
                                    myself.metadata._skip[campo.cmp_coluna] !==
                                      true)
                              "
                            >
                              <component
                                :key="index"
                                v-if="
                                  mycomponents[
                                    'tpluser' + myself.module + '--wcampo'
                                  ] != null
                                "
                                v-bind:is="
                                  'tpluser' + myself.module + '--wcampo'
                                "
                                :myself="myself"
                                :campo="campo"
                              />

                              <component
                                :key="index"
                                v-else-if="
                                  mycomponents[
                                    'tpluser' +
                                      myself.lista.modulo.tpl +
                                      '--wcampo'
                                  ] != null
                                "
                                v-bind:is="
                                  'tpluser' +
                                    myself.lista.modulo.tpl +
                                    '--wcampo'
                                "
                                :myself="myself"
                                :campo="campo"
                              />

                              <component
                                :key="index"
                                v-else-if="
                                  mycomponents[
                                    'listagem-' + myself.module + '-wcampo'
                                  ] != null
                                "
                                v-bind:is="
                                  'listagem-' + myself.module + '-wcampo'
                                "
                                :myself="myself"
                                :campo="campo"
                              />

                              <slot
                                name="wcampo"
                                v-else
                                v-bind:myself="myself"
                                v-bind:aba="aba"
                                v-bind:index="index"
                                v-bind:secao="secao"
                                v-bind:indexsec="indexsec"
                                v-bind:campo="campo"
                              >
                                <v-flex
                                  class="content-put-default"
                                  :style="campo.cmp_cssstyle"
                                  :class="
                                    'crudcampo-' +
                                      myself.action +
                                      ' text-xs-left pa-1 sm' +
                                      campo.tpl +
                                      ' ' +
                                      (campo.cmp_cssclass || '') +
                                      ' class_campo_' +
                                      (campo.cmp_coluna || '')
                                  "
                                  :key="index"
                                >
                                  <component
                                    v-if="
                                      mycomponents[
                                        'tpluser' + myself.module + '--campo'
                                      ] != null
                                    "
                                    v-bind:is="
                                      'tpluser' + myself.module + '--campo'
                                    "
                                    :myself="myself"
                                    :campo="campo"
                                  />

                                  <component
                                    v-else-if="
                                      mycomponents[
                                        'tpluser' +
                                          myself.lista.modulo.tpl +
                                          '--campo'
                                      ] != null
                                    "
                                    v-bind:is="
                                      'tpluser' +
                                        myself.lista.modulo.tpl +
                                        '--campo'
                                    "
                                    :myself="myself"
                                    :campo="campo"
                                  />

                                  <component
                                    v-else-if="
                                      mycomponents[
                                        'listagem-' + myself.module + '-campo'
                                      ] != null
                                    "
                                    v-bind:is="
                                      'listagem-' + myself.module + '-campo'
                                    "
                                    :myself="myself"
                                    :campo="campo"
                                  />

                                  <slot
                                    name="campo"
                                    v-else
                                    v-bind:myself="myself"
                                    v-bind:aba="aba"
                                    v-bind:index="index"
                                    v-bind:secao="secao"
                                    v-bind:indexsec="indexsec"
                                    v-bind:campo="campo"
                                  >
                                    <h4 class="put-default-title">
                                      {{ T(campo.cmp_titulo) }}
                                    </h4>
                                    <crudcampo
                                      :crud="myself"
                                      v-model="myself.form[campo.cmp_coluna]"
                                      :campo="campo"
                                      :row="myself.form"
                                    ></crudcampo>
                                  </slot>
                                </v-flex>
                              </slot>
                            </template>

                            <v-flex
                              class="xs12"
                              v-else-if="campo.m == 'DIV'"
                              :key="index"
                            ></v-flex>

                            <v-flex
                              class="xs12"
                              v-else-if="campo.m == 'O'"
                              :key="index"
                            >
                              <h2 class="grey" v-if="campo.o[0] == '+secao'">
                                {{ T(campo.o[1]) }}
                              </h2>
                              <hr class="grey" v-if="campo.o[0] == '-secao'" />
                            </v-flex>
                          </template>
                        </v-layout>
                      </v-card>
                    </slot>
                  </div>
                </template>

                <slot name="abagroup" v-bind:myself="myself">
                <v-tabs
                  v-model="myself.abasmodel"
                  color="primary"
                  dark
                  slider-color="black"
                  class="elevation-1"
                  v-if="
                    myself.abas != null &&
                      myself.abas.filter(v => v.nome != null).length > 0
                  "
                >
                  <slot
                    name="abatitle"
                    v-for="(aba, index) in myself.abas"
                    v-bind:myself="myself"
                    v-bind:aba="aba"
                    v-bind:index="index"
                  >
                    <v-tab
                      :key="index"
                      v-if="aba.nome != null"
                      v-show="quantosExibir(aba) > 0"
                      >{{ T(aba.nome) }}</v-tab
                    >
                  </slot>

                  <slot
                    name="abacontent"
                    v-for="(aba, index) in myself.abas"
                    v-bind:myself="myself"
                    v-bind:aba="aba"
                    v-bind:index="index"
                  >
                    <v-tab-item class :key="index" v-if="aba.nome != null">
                      <slot
                        name="secao"
                        v-bind:myself="myself"
                        v-bind:aba="aba"
                        v-bind:index="index"
                        v-bind:secao="secao"
                        v-bind:indexsec="indexsec"
                        v-for="(secao, indexsec) in aba.secoes"
                        v-if="secao.campos.length > 0"
                      >
                        <v-card
                          class="ma-2 pa-2 elevation-0 class_secao"
                          :key="indexsec"
                        >
                          <v-subheader
                            v-if="secao.nome != null"
                            class="blue lighten-5"
                            >{{ T(secao.nome) }}</v-subheader
                          >

                          <v-layout row wrap style="position: relative">
                            <template v-for="(campo, index) in secao.campos">
                              <template
                                v-if="
                                  campo.m == null &&
                                    (myself.metadata._skip == null ||
                                      myself.metadata._skip[
                                        campo.cmp_coluna
                                      ] !== true)
                                "
                              >
                                <component
                                  :key="index"
                                  v-if="
                                    mycomponents[
                                      'tpluser' + myself.module + '--wcampo'
                                    ] != null
                                  "
                                  v-bind:is="
                                    'tpluser' + myself.module + '--wcampo'
                                  "
                                  :myself="myself"
                                  :campo="campo"
                                />

                                <component
                                  :key="index"
                                  v-else-if="
                                    mycomponents[
                                      'tpluser' +
                                        myself.lista.modulo.tpl +
                                        '--wcampo'
                                    ] != null
                                  "
                                  v-bind:is="
                                    'tpluser' +
                                      myself.lista.modulo.tpl +
                                      '--wcampo'
                                  "
                                  :myself="myself"
                                  :campo="campo"
                                />

                                <component
                                  :key="index"
                                  v-else-if="
                                    mycomponents[
                                      'listagem-' + myself.module + '-wcampo'
                                    ] != null
                                  "
                                  v-bind:is="
                                    'listagem-' + myself.module + '-wcampo'
                                  "
                                  :myself="myself"
                                  :campo="campo"
                                />

                                <slot
                                  name="wcampo"
                                  v-else
                                  v-bind:myself="myself"
                                  v-bind:aba="aba"
                                  v-bind:index="index"
                                  v-bind:secao="secao"
                                  v-bind:indexsec="indexsec"
                                  v-bind:campo="campo"
                                >
                                  <v-flex
                                    class="content-put-default"
                                    :style="campo.cmp_cssstyle"
                                    :class="
                                      'crudcampo-' +
                                        myself.action +
                                        ' text-xs-left pa-1 sm' +
                                        campo.tpl +
                                        ' ' +
                                        (campo.cmp_cssclass || '') +
                                        ' class_campo_' +
                                        (campo.cmp_coluna || '')
                                    "
                                    :key="index"
                                  >
                                    <component
                                      v-if="
                                        mycomponents[
                                          'tpluser' + myself.module + '--campo'
                                        ] != null
                                      "
                                      v-bind:is="
                                        'tpluser' + myself.module + '--campo'
                                      "
                                      :myself="myself"
                                      :campo="campo"
                                    />

                                    <component
                                      v-else-if="
                                        mycomponents[
                                          'tpluser' +
                                            myself.lista.modulo.tpl +
                                            '--campo'
                                        ] != null
                                      "
                                      v-bind:is="
                                        'tpluser' +
                                          myself.lista.modulo.tpl +
                                          '--campo'
                                      "
                                      :myself="myself"
                                      :campo="campo"
                                    />

                                    <component
                                      v-else-if="
                                        mycomponents[
                                          'listagem-' + myself.module + '-campo'
                                        ] != null
                                      "
                                      v-bind:is="
                                        'listagem-' + myself.module + '-campo'
                                      "
                                      :myself="myself"
                                      :campo="campo"
                                    />

                                    <slot
                                      name="campo"
                                      v-else
                                      v-bind:myself="myself"
                                      v-bind:aba="aba"
                                      v-bind:index="index"
                                      v-bind:secao="secao"
                                      v-bind:indexsec="indexsec"
                                      v-bind:campo="campo"
                                    >
                                      <h4 class="put-default-title">
                                        {{ T(campo.cmp_titulo) }}
                                      </h4>
                                      <crudcampo
                                        :crud="myself"
                                        v-model="myself.form[campo.cmp_coluna]"
                                        :campo="campo"
                                        :row="myself.form"
                                      ></crudcampo>
                                    </slot>
                                  </v-flex>
                                </slot>
                              </template>

                              <v-flex
                                class="xs12"
                                v-else-if="campo.m == 'DIV'"
                                :key="index"
                              ></v-flex>

                              <v-flex
                                class="xs12"
                                v-else-if="campo.m == 'O'"
                                :key="index"
                              >
                                <h2 class="grey" v-if="campo.o[0] == '+secao'">
                                  {{ T(campo.o[1]) }}
                                </h2>
                                <hr
                                  class="grey"
                                  v-if="campo.o[0] == '-secao'"
                                />
                              </v-flex>
                            </template>
                          </v-layout>
                        </v-card>
                      </slot>
                    </v-tab-item>
                  </slot>
                </v-tabs>
                </slot>

                <component
                  v-if="
                    mycomponents['tpluser' + myself.module + '--btnbar'] != null
                  "
                  v-bind:is="'tpluser' + myself.module + '--btnbar'"
                  :myself="myself"
                  :form="$refs.form"
                />

                <component
                  v-else-if="
                    mycomponents[
                      'tpluser' + myself.lista.modulo.tpl + '--btnbar'
                    ] != null
                  "
                  v-bind:is="'tpluser' + myself.lista.modulo.tpl + '--btnbar'"
                  :myself="myself"
                  :form="$refs.form"
                />

                <component
                  v-else-if="
                    mycomponents['listagem-' + myself.module + '-btnbar'] !=
                      null
                  "
                  v-bind:is="'listagem-' + myself.module + '-btnbar'"
                  :myself="myself"
                  :form="$refs.form"
                />

                <slot
                  name="btnbar"
                  v-bind:myself="myself"
                  v-bind:form="$refs.form"
                  v-else
                >
                  <v-btn
                    class="right"
                    color="success"
                    v-if="myself.action == 'new' || myself.action == 'edit'"
                    :disabled="!myself.valid"
                    @click="myself._formSubmit($refs.form)"
                    >{{ T("Salvar") }}</v-btn
                  >

                  <span class="right" v-if="myself.form._flowaction">
                    <v-btn
                      color="success"
                      v-if="
                        myself.action == 'flow' &&
                          myself.avaliaPermissao('flowact_' + action.act)
                      "
                      v-for="(action, indc) in myself.form._flowaction"
                      :key="'flowaction_' + indc"
                      :disabled="!myself.valid"
                      @click="myself._formSubmit($refs.form, action.act)"
                      >{{ T(action.name) }}</v-btn
                    >
                  </span>

                  <v-btn
                    class="right no-shadow"
                    @click="myself._formClear($refs.form)"
                    v-if="myself.action == 'new'"
                    >{{ T("Limpar") }}</v-btn
                  >
                  <v-btn class="left no-shadow" @click="myself._goBack()">{{
                    T("Voltar")
                  }}</v-btn>
                </slot>
              </v-form>
            </slot>

            <slot
              name="tplbox"
              v-bind:myself="myself"
              v-bind:admintpl="admintpl"
              v-bind:closeTpl="closeTpl"
            >
              <v-card
                v-if="admintpl == true"
                class="table-tamplete-son no-shadow"
                style
              >
                <v-card-title class="text-xs-center center-content-flex">
                  <v-btn class="primary" @click="updateTplReverte()">{{
                    T("Reverter")
                  }}</v-btn>
                  <v-btn @click="admintpl = false" class="no-shadow">{{
                    T("Fechar")
                  }}</v-btn>
                </v-card-title>

                <h2 class="title-templete-form">{{ T("Templete") }}</h2>

                <v-card-text>
                  <v-textarea
                    style
                    v-model="myself.lista.modulo.tplparam"
                    @input="updateTpl()"
                    hide-details
                    box
                    rows="30"
                  ></v-textarea>
                </v-card-text>
              </v-card>
            </slot>

            <v-btn
              v-if="devmode && myself.localsession[myself.sid].joined == null"
              @click="admintpl = !admintpl"
              class="no-shadow"
              >{{ T("Template") }}</v-btn
            >

            <v-btn
              v-if="devmode && myself.localsession[myself.sid].joined == null"
              @click="absolutetpl = !absolutetpl"
              class="no-shadow"
              icon
              fab
              small
            >
              <v-icon>open_with</v-icon>
            </v-btn>

            <div style="clear: both"></div>

            <component
              v-if="
                mycomponents['tpluser' + myself.module + '--posform'] != null
              "
              v-bind:is="'tpluser' + myself.module + '--posform'"
              :myself="myself"
            />

            <component
              v-if="
                mycomponents[
                  'tpluser' + myself.lista.modulo.tpl + '--posform'
                ] != null
              "
              v-bind:is="'tpluser' + myself.lista.modulo.tpl + '--posform'"
              :myself="myself"
            />

            <component
              v-if="
                mycomponents['listagem-' + myself.module + '-posform'] != null
              "
              v-bind:is="'listagem-' + myself.module + '-posform'"
              :myself="myself"
            />

            <slot name="posform" v-bind:myself="myself"></slot>
          </v-card>
        </article>
      </template>

      <template>
        <component
          v-if="mycomponents['tpluser' + myself.module + '--dialog'] != null"
          v-bind:is="'tpluser' + myself.module + '--dialog'"
          :myself="myself"
        />
        <component
          v-else-if="
            mycomponents['tpluser' + myself.lista.modulo.tpl + '--dialog'] !=
              null
          "
          v-bind:is="'tpluser' + myself.lista.modulo.tpl + '--dialog'"
          :myself="myself"
        />

        <component
          v-else-if="
            myself.form !== null &&
              mycomponents['listagem-' + myself.module + '-dialog'] != null
          "
          v-bind:is="'listagem-' + myself.module + '-dialog'"
          :myself="myself"
        />

        <slot name="dialog" v-bind:myself="myself" v-else>
          <v-dialog
            :width="myself.displayDialogData.width || '800'"
            v-if="myself.displayDialog"
            v-model="myself.displayDialog"
          >
            <v-card>
              <v-toolbar
                v-if="myself.displayDialogData.hasTitle !== false"
                class="headline grey lighten-2"
              >
                <v-toolbar-title class="title">{{
                  T(myself.displayDialogData.titulo)
                }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items class="hidden-sm-and-down">
                  <v-btn
                    small
                    @click="addnewBack()"
                    style="
                      height: 50px !important;
                      width: 50px !important;
                      min-width: 50px;
                      border-radius: 50% !important;
                      background-color: #fff;
                    "
                  >
                    <v-icon style="font-size: 24px">close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>

              <crud-tag
                :embedprops="{
                  params: {
                    module: myself.displayDialogData.tabela,
                    action: myself.displayDialogData.action,
                    id: myself.displayDialogData.id
                  },

                  query: myself.displayDialogData.jid
                    ? {
                        joined: myself.displayDialogData.jtabela,
                        joinedid: myself.displayDialogData.jid,
                        joinedfrom: myself.displayDialogData.tabela,
                        joinedsid:
                          myself.displayDialogData.sid || new Date().getTime()
                      }
                    : {
                        data: myself.displayDialogData.data
                      },
                  props: myself.displayDialogData.props || {
                    filtro: false,
                    gc: false,
                    rodape: true,
                    paginacao: false,
                    titulo: false,
                    select: false,
                    exportserver: false
                  }
                }"
                :backfn="() => addnewBack()"
                :returnfn="data => addnewSave(data)"
              />
            </v-card>
          </v-dialog>
        </slot>
      </template>
    </span>
  </span>
</template>

<script>
const crudcampo = global.reqClass.requirecmpmix("@/admin/listagem/crudcampo");

const components = { crudcampo };

try {
  require("@/lib/_autoload.js");
} catch (err) {
  try {
    require("@/framework/lib/_autoload.js");
  } catch (err) {}
}

/*****HACK CARREGA COMPONENTES DE PAGES */
if (global.appmap_auto && global.appmap_auto.pageloaded) {
  for (let cnome of global.appmap_auto.pageloaded) {
    let splitted = cnome.split("/");
    components[
      "pageloaded_" + splitted.join("-")
    ] = global.reqClass.requirecmpmix("@/page" + cnome);
  }
}
/*****HACK CARREGA COMPONENTES DE PAGES */

for (let cnome of global.reqClass.pageroutes) {
  if (cnome.startsWith("/listagem/")) {
    let splitted = cnome.replace("/listagem/", "/").split("/");
    components["listagem" + splitted.join("-")] = global.reqClass.requirecmpmix(
      "@/page" + cnome
    );
  }
}

//console.log("PAGES EXISTS ", Object.keys(components));

for (let cnome of global.reqClass.tpluser_client) {
  if (
    cnome.endsWith("--items") ||
    cnome.endsWith("--filtros") ||
    cnome.endsWith("--gc") ||
    cnome.endsWith("--addbtn") ||
    cnome.endsWith("--empty") ||
    cnome.endsWith("--footer") ||
    cnome.endsWith("--headers") ||
    cnome.endsWith("--dialog") ||
    cnome.endsWith("--datatable") ||
    cnome.endsWith("--full_search") ||
    cnome.endsWith("--exportscreen") ||
    cnome.endsWith("--exportserver") ||
    cnome.endsWith("--form") ||
    cnome.endsWith("--absoluteform") ||
    cnome.endsWith("--top") ||
    cnome.endsWith("--pretop") ||
    cnome.endsWith("--postop") ||
    cnome.endsWith("--predatatable") ||
    cnome.endsWith("--posdatatable") ||
    cnome.endsWith("--posform") ||
    cnome.endsWith("--loadmore") ||
    cnome.endsWith("--loadmoretop") ||
    cnome.endsWith("--campo") ||
    cnome.endsWith("--wcampo") ||
    cnome.endsWith("--btnbar")
  )
    components["tpluser" + cnome] = global.reqClass.requirecmpmix(
      "@/lib/tpl/" + cnome
    );
}

import InfiniteLoading from "vue-infinite-loading";
components["InfiniteLoading"] = InfiniteLoading;
export default {
  props: ["myself"],
  data() {
    return {
      datatable_resort: 0,
      paginaMapeada: null,
      originalTpl: this.myself.lista.modulo.tplparam,
      admintpl: false,
      absolutetpl: false,
      devmode: global.config.devmode,
      filtrobox: this.myself.configprops.openfiltro ? true : false,
      mycomponents: components
    };
  },

  computed: {
    temAlgumFiltro() {
      if (this.myself.localsession[this.myself.sid].filtro != null) {
        for (let x in this.myself.localsession[this.myself.sid].filtro) {
          let el = this.myself.localsession[this.myself.sid].filtro[x];
          // console.log("AVAL", x, el);
          if (el !== null && el !== "" && el !== undefined) {
            return true;
          }
        }
      }
      //console.log("END");
      return false;
    }
  },

  /*****HACK CARREGA COMPONENTES DE PAGES */
  beforeMount() {
    this.loadPaginaMapeada();
    this.originalTpl = this.myself.lista.modulo.tplparam;

    if (this.myself.lista.modulo.mod_paginacao_infinita != null) {
      this.myself.configprops.paginacao = false;
    }
    this.myself.configprops.colsort = true;
  },

  directives: {
    sortable: {
      inserted: function(el, binding, vNode) {
        try {
          if (vNode.context.myself.configprops.colsort == true)
            new Sortable(el, binding.value || {});
        } catch (err) {}
      }
    }
  },

  methods: {
    updateHeaderOrder(evt) {
      console.log(evt, evt.clone.getAttribute("keyname"));

      let headers = this.myself.headers;
      let old_index = evt.oldIndex;
      if (evt.clone.getAttribute("keyname") == null) {
        this.datatable_resort = new Date().getTime();
        return;
      }

      let new_index = evt.newIndex;

      if (
        this.myself.configprops.select &&
        this.myself.lista.modulo.mod_numero
      ) {
        old_index--;
        new_index--;
      }

      let rem = this.myself.headers.splice(old_index, 1)[0];
      this.myself.headers.splice(new_index, 0, rem);
      this.datatable_resort = new Date().getTime();
      //- by setting an id as a :key on the table
      //- we force it to redraw when headers are moved

      ///Gravar os pesos na memoria.

      let mapsort = {};
      for (let hi in this.myself.headers) {
        let h = this.myself.headers[hi];
        mapsort[h.value] = hi;
      }

      this.$store.dispatch("setConfig", [
        "COL_SORT_" + this.myself.lista.modulo.mod_tabela,
        mapsort
      ]);
    },

    addnewBack() {
      this.myself.displayDialog = false;
    },
    addnewSave(data) {
      //console.log("POSFORM", data);
      if (this.myself.displayDialogData.callback) {
        this.myself.displayDialogData.callback(data.obj);
      } else {
      }
      this.myself.forceReload();
      this.myself.displayDialog = false;
    },

    quantosExibir(aba) {
      let allnome = [];
      for (let secao of aba.secoes)
        for (let campo of secao.campos) {
          if (campo.cmp_coluna != null) allnome.push(campo.cmp_coluna);
        }

      let count = 0;
      for (let col of allnome) {
        if (
          this.myself.metadata._skip == null ||
          this.myself.metadata._skip[col] !== true
        ) {
          count++;
        }
      }
      return count;
    },
    limparTodoFiltro() {
      this.myself.localsession[this.myself.sid].filtro = {};
      window.document.getElementById("botaoFiltarPadrao").click();
    },
    loadPaginaMapeada() {
      // global.componentMapPageNome = this.myself.pageloaded;
      //console.log(global.componentMapPageNome);
      this.paginaMapeada =
        "pageloaded_" + (this.myself.pageloaded||'').split("/").join("-");
    },
    updateTpl() {
      this.myself.abas = this.myself._trataTpl(
        this.myself.lista.modulo.tplparam,
        this.myself.lista.campos,
        this.myself.action
      );
    },
    updateTplReverte() {
      this.myself.lista.modulo.tplparam = this.originalTpl;
      this.updateTpl();
    },
    closeTpl() {
      this.admintpl = false;
    },

    print() {
      // Pass the element id here
      this.$htmlToPaper("printableList");
    }
  },
  watch: {
    $refs: {
      handler(old, newv) {
        this.myself.$refs = this.$refs;
      },
      immediate: true
    },

    "myself.pageloaded": {
      handler(old, newv) {
        this.loadPaginaMapeada();
      }
    }
  },
  /*****HACK CARREGA COMPONENTES DE PAGES */

  components
};
</script>

<style>
.crudtable {
  width: 100%;
}
.v-tabs__item {
  color: #fff !important;
}

.tabelaFiltro {
  border-collapse: collapse;
}
.tabelaFiltro tr td,
.tabelaFiltro tr th {
  border: solid #eee 1px;
  padding: 2px;
}
.boldlink {
  text-decoration: underline;
  text-decoration-color: #ccc;
}

.form_tabelado_view h4 {
  background-color: #f0f0f0;
  font-size: 12px !important;
  margin-top: 0px;
}

@media print {
  nav,
  .v-navigation-drawer,
  .v-speed-dial,
  .v-breadcrumbs,
  .gerenciarCampos,
  .caixaDeFiltro,
  .addBotao {
    display: none;
  }
  #app {
    margin-top: 0px;
  }
  main {
    padding: 0 0 0 0 !important;
  }
}
</style>
